export const UPDATE_CONTROL_DELAY = 1000

export const OBJECTIVE_WARNING =
  'Caution: Editing the objective changes this control materially. Policy, procedure, and evidence may need to change.'

export const GUIDANCE_WARNING =
  'Great care should be taken when editing. The Trustero Customer Success and GRC teams are happy to help with this process.'

export enum ControlQueryParams {
  DEFAULT_TAB = 'defaultTab',
}

export enum ControlTabParams {
  OVERVIEW = 'overview',
  REQUESTS = 'requests',
  EVIDENCE = 'evidence',
  AUDIT_SCANS = 'audit-scans',
  EVIDENCE_SUGGESTIONS = 'evidence-suggestions',
  RISKS = 'risks',
  GUIDANCE = 'guidance',
  NOTES = 'notes',
}

export enum ControlTabTitles {
  OVERVIEW = 'Overview',
  REQUESTS = 'Requests',
  EVIDENCE = 'Evidence',
  AUDIT_SCANS = 'Control Test',
  EVIDENCE_SUGGESTIONS = 'Automated Evidence',
  RISKS = 'Risks',
  GUIDANCE = 'Guidance',
  NOTES = 'Notes',
}

export const CONTROL_TAB_PARAM_TO_TITLE: Record<
  ControlTabParams,
  ControlTabTitles
> = {
  [ControlTabParams.OVERVIEW]: ControlTabTitles.OVERVIEW,
  [ControlTabParams.REQUESTS]: ControlTabTitles.REQUESTS,
  [ControlTabParams.EVIDENCE]: ControlTabTitles.EVIDENCE,
  [ControlTabParams.AUDIT_SCANS]: ControlTabTitles.AUDIT_SCANS,
  [ControlTabParams.EVIDENCE_SUGGESTIONS]:
    ControlTabTitles.EVIDENCE_SUGGESTIONS,
  [ControlTabParams.RISKS]: ControlTabTitles.RISKS,
  [ControlTabParams.GUIDANCE]: ControlTabTitles.GUIDANCE,
  [ControlTabParams.NOTES]: ControlTabTitles.NOTES,
}

/** Stable keys for control show page tabs. */
export enum ControlShowTabKey {
  OVERVIEW = 'overview-tab',
  REQUESTS = 'requests-tab',
  EVIDENCE = 'evidence-tab',
  EVIDENCE_SUGGESTIONS = 'evidence-suggestions-tab',
  AUDIT_SCANS = 'audit-scans-tab',
  RISKS = 'risks-tab',
  GUIDANCE = 'guidance-tab',
  NOTES = 'notes-tab',
}
